import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';
import SuspenseContent from './containers/SuspenseContent';
import updateSW from './pwaServiceWorker';
import 'react-tooltip/dist/react-tooltip.css';

// Call updateSW to initialize the service worker
updateSW();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Suspense fallback={<SuspenseContent />}>
		<Provider store={store}>
			<App />
		</Provider>
	</Suspense>
);